module.exports = __webpack_public_path__ + "static/media/S1_00045.53b26ece.jpg";